import useUser from '../../../api/healthCoach/useUser';
import { formatDate } from '../utils';
import OverviewCard from './OverviewCard';

export const GutCheckCountCard = () => {
  const {
    user: { amount_completed_gut_checks, last_gut_check } = {},
    isLoading,
  } = useUser();

  return (
    <OverviewCard
      title={'Gut Checks'}
      text={amount_completed_gut_checks}
      bottomTag={{
        text: `Last survey: ${formatDate(
          last_gut_check || undefined,
          'MMM D'
        )}`,
      }}
      flexGrow={3}
      loading={isLoading}
    />
  );
};

export default GutCheckCountCard;
